export const passwordChangeInitial = {
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
};
export const nameChangeInitial = {
  currentName: "",
  newName: "",
  confirmName: "",
};
export const emailChangeInitial = {
  currentEmail: "",
  newEmail: "",
  confirmEmail: "",
};

export const handleChange = (event, setFunction, fields) => {
  const { value, name } = event.target;
  setFunction({ ...fields, [name]: value });
};
export const changePassword = async (event, fields) => {
  event.preventDefault();
  if (fields["newPassword"] === fields["confirmPassword"]) {
    try {
      const response = await fetch(
        "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/user/auth/changepassword",
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            "auth-token": localStorage.getItem("user"),
          },
          body: JSON.stringify(fields),
        }
      );
      const result = await response.json();
      window.location.reload();
    } catch (error) {
      console.log(error.message);
      alert(error.message);
    }
  } else {
    alert("Passwords don't match");
  }
};

export const changeName = async (event, fields) => {
  event.preventDefault();

  if (fields["newName"] === fields["confirmName"]) {
    try {
      const response = await fetch(
        "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/user/auth/changename",
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            "auth-token": localStorage.getItem("user"),
          },
          body: JSON.stringify(fields),
        }
      );
      const result = await response.json();
      window.location.reload();
    } catch (error) {
      console.log(error.message);
      alert(error.message);
    }
  } else {
    alert("Names don't match");
  }
};
export const changeEmail = async (event, fields) => {
  event.preventDefault();
  if (fields["newEmail"] === fields["confirmEmail"]) {
    try {
      const response = await fetch(
        "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/user/auth/changeemail",
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            "auth-token": localStorage.getItem("user"),
          },
          body: JSON.stringify(fields),
        }
      );
      const result = await response.json();
      window.location.reload();
    } catch (error) {
      console.log(error.message);
      alert(error.message);
    }
  } else {
    alert("Emails don't match");
  }
};
